import React, { useContext, useEffect, useState } from "react";
import LoginContext from "../../context";
import { Link } from "react-router-dom";
import top_bar_icon from "../../assets/images/top_bar_icon.png";
const TopBar = () => {
  const { openLoginPopup, isAuthenticated, logout, user, token } =
    useContext(LoginContext);

  const [cash, setCash] = useState("0");
  const [points, setPoints] = useState("0");
  const [casino, setCasino] = useState("0");

  const fetchBalances = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/transactions/balances/my-balance`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: token?.token ? `Bearer ${token.token}` : "",
          },
        }
      );
      const data = await res.json();
      setCash(data.cash_balance || cash);
      setPoints(data.points_balance || points);
      setCasino(data.casino_balance || casino);
    } catch (error) {
      console.error("balance fetch failed:", error);
    }
  };

  const convertPointsToCash = async () => {
    const confirm = window.confirm(
      "현재 마일리지를 보유금액으로 전환하시겠습니까?"
    );
    if (!confirm) return;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/transactions/balances/convert-points-to-cash`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            Authorization: token?.token ? `Bearer ${token.token}` : "",
          },
        }
      );

      const data = await res.json();

      if (res.ok) {
        // setCash(data.cash_balance || cash);
        // setPoints(data.points_balance || points);
        // setCasino(data.casino_balance || casino);
        alert(
          `전환이 완료되었습니다.\n보유금액: ${data.cash_balance}원\n포인트: ${data.points_balance}원`
        );
        await fetchBalances();
      } else {
        alert(data?.error || "전환 중 오류가 발생했습니다.");
      }
    } catch (error) {
      alert("네트워크 오류가 발생했습니다.");
      console.error("Error converting points:", error);
    }
  };

  const convertCasinoToCash = async () => {
    const confirm = window.confirm("카지노 머니를 현금으로 전환하시겠습니까?");
    if (!confirm) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/transactions/balances/convert-casino-to-cash`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            Authorization: token?.token ? `Bearer ${token.token}` : "",
          },
        }
      );

      const data = await res.json();

      if (res.ok) {
        // setCash(data.cash_balance || cash);
        // setPoints(data.points_balance || points);
        // setCasino(data.casino_balance || casino);
        alert(
          `전환이 완료되었습니다.\n보유금액: ${data.cash_balance}원\n포인트: ${data.points_balance}원\n카지노머니: ${data.casino_balance}원`
        );
        await fetchBalances();
      } else {
        alert(data?.error || "전환 중 오류가 발생했습니다.");
      }
    } catch (error) {
      alert("네트워크 오류가 발생했습니다.");
      console.error("Error converting casino:", error);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchBalances();
    }
  }, [isAuthenticated]);

  return (
    <>
      <section
        className={`top-bar ${isAuthenticated ? "h-10 lg:h-[80px] xl:h-[50px]" : "lg:h-[50px]"
          }  bg-obsidian lg:bg-charcoal flex justify-between items-center py-[5px] lg:py-0 lg:px-2.5 relative`}
      >
        <div className="h-[50px] w-[35%] hidden lg:flex  items-center gap-[25px]">
          <i className="icofont icofont-megaphone-alt text-xl text-aquaBlue "></i>
          <div className="text-xs overflow-hidden w-full">
            <p className="text-[#fe1100] marquee-animation w-max font-Time">
              ♥ 나루토카지노 평생 도메인 : 나루토카지노.com ♥{" "}
            </p>
          </div>
        </div>

        {isAuthenticated ? (
          <>
            <div className="leading-10 lg:hidden font-sans-serif w-full">
              <ul className="text-center text-xs flex items-center justify-center w-full">
                <li className="mx-[3px] inline-block text-white">
                  <a href="#">
                    <i className="icofont icofont-won me-1"></i>
                    <span>
                      <strong className="text-skyblue font-bold">0</strong>
                    </span>
                  </a>
                </li>
                <li className="mx-[3px] inline-block text-white">
                  <a href="#" className="PointChange" intmp="0">
                    <i className="icofont icofont-peseta me-1"></i>
                    <strong className="text-skyblue font-bold">0 P</strong>
                  </a>
                </li>
                <li className="mx-[3px] inline-block text-white">
                  <i className="icofont icofont-dice"></i>
                  <span className="text-skyblue font-bold inline-block mx-1">
                    0
                  </span>
                  <button type="button" className="text-white text-xs">
                    {" "}
                    <i className="icofont icofont-refresh"></i>{" "}
                  </button>
                  <button type="button" className="text-white text-xs ml-1">
                    {" "}
                    [ 전환 ]{" "}
                  </button>{" "}
                </li>
              </ul>
            </div>

            <ul className="text-sm absolute right-5 top-0 hidden lg:flex justify-center items-center font-Serif gap-1 xl:gap-0">
              <li className="text-white px-[5px] h-[50px] leading-[50px]">
                <span className="level_icon">
                  <img
                    src={top_bar_icon}
                    className="align-middle -mt-0.5 w-[25px] inline-block me-1"
                  />
                </span>
                <strong>{user?.username || user?.name}</strong>님
              </li>
              <li className="xl:flex items-center">
                <div className="text-white px-[5px] xl:h-[50px] xl:leading-[50px]  my-2.5 xl:my-0">
                  <Link
                    to="/cash_1"
                    className="hover:text-aquaBlue tranition-all duration-300"
                  >
                    <i className="icofont icofont-won text-aquaBlue me-1"></i>
                    보유금액 :{" "}
                    <span>
                      <strong className="text-aquaBlue font-bold">
                        {cash}
                      </strong>
                    </span>
                    원
                  </Link>
                </div>
                <div className="text-white px-[5px] xl:h-[50px] xl:leading-[50px]">
                  <span className="hover:text-aquaBlue transition-all duration-300">
                    <i className="icofont icofont-peseta text-aquaBlue me-1"></i>
                    포인트 :{" "}
                    <strong className="text-aquaBlue font-bold">
                      {points}
                    </strong>
                    원
                    <span
                      className="ml-2 text-aquaBlue font-bold cursor-pointer underline hover:opacity-80"
                      onClick={convertPointsToCash}
                    >
                      [전환]
                    </span>
                  </span>
                </div>
              </li>
              <li className="text-white px-[5px] xl:h-[50px] xl:leading-[50px]">
                <div className="xl:flex items-center">
                  <div className="my-2.5 xl:my-0">
                    <i className="icofont icofont-dice text-aquaBlue me-1"></i>
                    카지노머니 :{" "}
                    <span className="text-aquaBlue font-bold me-1">
                      {casino}
                    </span>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={fetchBalances}
                      className="bg-[#0E8700] h-5 leading-5 px-[5px] rounded-[4px] text-white text-xs me-1"
                    >
                      새로고침
                    </button>

                    <button
                      type="button"
                      onClick={convertCasinoToCash}
                      className="bg-[#881719] h-5 leading-5 px-[5px] rounded-[4px] text-white text-xs"
                    >
                      미니전환
                    </button>
                  </div>
                </div>
              </li>
              <li className="xl:flex items-center">
                <div className="text-white px-[5px] xl:h-[50px] xl:leading-[50px]  my-2.5 xl:my-0">
                  <a
                    href="#"
                    className="text-white rounded-[5px] h-[25px] leading-[25px] text-center w-[80px] font-bold text-xs inline-block bg-blue-glow hover:text-black hover:filter hover:brigthness-[1.2] transition-all duration-300"
                    title="출석하기"
                    onClick={() => {
                      alert("출석부");
                    }}
                  >
                    출석부
                  </a>
                </div>
                <div className="text-white px-[5px] xl:h-[50px] xl:leading-[50px] ">
                  <button
                    className="text-white rounded-[5px] h-[25px] leading-[25px] text-center w-[80px] font-bold text-xs inline-block bg-blue-glow hover:text-black hover:filter hover:brigthness-[1.2] transition-all duration-300"
                    title="로그아웃"
                    onClick={logout}
                  >
                    {" "}
                    로그아웃
                  </button>
                </div>
              </li>
            </ul>
          </>
        ) : (
          <>
            <div className="flex justify-center lg:justify-start gap-1 w-full lg:w-auto  py-[5px] lg:py-0 bg-obsidian lg:bg-[transparent] border-b border-slate lg:border-none ">
              <button
                className="bg-black lg:bg-blue-glow  uppercase w-[49%] lg:w-[150px] cursor-pointer text-base lg:text-[13px] text-white font-bold h-[50px] lg:h-[35px] leading-[50px] lg:leading-[35px] rounded-[10px] transition-all duration-300 ease-in-out border border-skyblue lg:border-[#0306d4] hover:filter hover:brightness-[1.5] text-center"
                onClick={openLoginPopup}
              >
                <i className="fa fa-user-circle-o me-1 lg:hidden"></i>
                로그인
              </button>
              <Link
                to="/info"
                className="bg-blue-glow  uppercase w-[49%] lg:w-[150px] cursor-pointer text-base lg:text-[13px] text-white font-bold h-[50px] lg:h-[35px] leading-[50px] lg:leading-[35px] rounded-[10px] transition-all duration-300 ease-in-out border border-[#0306d4] hover:filter hover:brightness-[1.5] text-center"
              >
                <i className="fa fa-plus-circle me-1 lg:hidden"></i>
                회원가입
              </Link>
            </div>
          </>
        )}
      </section>
    </>
  );
};

export default TopBar;
